export default function updateData<T>(data: T, props: any) {
    for (const key in props) {
        if (props.hasOwnProperty(key)) {
            if (typeof props[key] === 'object')
                (data as any)[key] = JSON.parse(JSON.stringify(props[key]));
            else
                (data as any)[key] = props[key];
        }
    }
    return data
}